import React from "react";

import { SkeletonText } from "src/app/components/Skeleton/Skeleton";

export const skeletonOptions = [
  {
    value: "skeleton-1",
    label: (
      <span className="image-select-option">
        <SkeletonText height={20} width={180} />
      </span>
    ),
  },
  {
    value: "skeleton-2",
    label: (
      <span className="image-select-option">
        <SkeletonText height={20} width={180} />
      </span>
    ),
  },
  {
    value: "skeleton-3",
    label: (
      <span className="image-select-option">
        <SkeletonText height={20} width={180} />
      </span>
    ),
  },
  {
    value: "skeleton-4",
    label: (
      <span className="image-select-option">
        <SkeletonText height={20} width={180} />
      </span>
    ),
  },
  {
    value: "skeleton-5",
    label: (
      <span className="image-select-option">
        <SkeletonText height={20} width={180} />
      </span>
    ),
  },
  {
    value: "skeleton-6",
    label: (
      <span className="image-select-option">
        <SkeletonText height={20} width={180} />
      </span>
    ),
  },
];
